module.exports = __webpack_public_path__ + "img/shiba-loading.cf3c6bdf.png";